// extracted by mini-css-extract-plugin
module.exports = {"outer":"Modal_outer__b1bGQ","inner":"Modal_inner__2mdon","innerNatural":"Modal_innerNatural__msYxK","scrollable":"Modal_scrollable__24efB"};